import { getStorageItem, setStorageItem } from './localStorage';

const DEFAULT_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;

function canUseCookies(): boolean {
  return typeof document !== 'undefined';
}

function cookieOptions(maxAge = DEFAULT_MAX_AGE_SECONDS): string {
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
  return `Path=/; SameSite=Lax; Max-Age=${maxAge}${secure ? '; Secure' : ''}`;
}

export function getCookie(name: string): string | null {
  if (!canUseCookies()) return null;
  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));
  if (!cookie) return null;
  return decodeURIComponent(cookie.slice(prefix.length));
}

export function setCookie(name: string, value: string): void {
  if (!canUseCookies()) return;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ${cookieOptions()}`;
}

export function removeCookie(name: string): void {
  if (!canUseCookies()) return;
  document.cookie = `${encodeURIComponent(name)}=; ${cookieOptions(0)}`;
}

// One-shot move of a key that used to live in a cookie into localStorage (CORP-8298). Accounts
// small enough to fit in 4 KB do have a cookie today; without this they would lose the selected
// holding once, on the first load after the deploy. The cookie is dropped either way so the
// stale copy stops travelling in every request header.
export function migrateCookieToStorage(name: string): void {
  const value = getCookie(name);
  if (value === null) return;
  if (getStorageItem(name) === null) setStorageItem(name, value);
  removeCookie(name);
}
